/* eslint-disable no-useless-escape */

const delivery_options = {
    dp: [
        {
            id: 'deliverto',
            title: 'Standard Delivery',
            desc: '<p>Standard domestic delivery including named day options.<\/p>'
        },
        {
            id: 'shop',
            title: 'Collect from shop',
            desc: '<p>Collect from your nearest Jeroboams shop.<\/p>',
        },
        {
            id: 'reserve',
            title: 'Send to Jeroboams Private Reserve',
            desc: '<p>Store your purchases in perfect cellaring conditions with Jeroboams Private Reserve.<\/p>',
        },
        {
            id: 'warehouse',
            title: 'Bonded Warehouse',
            desc: '<p>Send your order to an external storage provider.<\/p>',
        }

    ],
    ib: [
        {
            id: 'reserve',
            title: 'Send to Jeroboams Private Reserve',
            desc: '<p>Store your purchases in perfect cellaring conditions with Jeroboams Private Reserve.<\/p>',
        },
        {
            id: 'warehouse',
            title: 'Bonded Warehouse',
            desc: '<p>Send your order to an external storage provider.<\/p>',
        }
    ]
};

function DeliveryOptions() {
    return delivery_options;
}

export default DeliveryOptions;